var parseTestCases = function (testCases) {
  return testCases.map(function (x, id) {
    var _a, _b, _c;
    var feedback = (_a = x.message) !== null && _a !== void 0 ? _a : "null";
    var passed = (_b = x.passed) !== null && _b !== void 0 ? _b : false;
    var testName = (_c = x.name) !== null && _c !== void 0 ? _c : "noTestName";
    return {
      id: id.toString(),
      feedback: feedback,
      passed: passed,
      testName: testName
    };
  });
};
var removeFalseIsNotTrue = function (input) {
  var matchFalse = input.match(/^False is not true : ([\s\S]+)/i);
  var matchTrue = input.match(/^True is not false : ([\s\S]+)/i);
  if (matchFalse) {
    return matchFalse[1];
  } else if (matchTrue) {
    return matchTrue[1];
  } else {
    return input;
  }
};
export { removeFalseIsNotTrue, parseTestCases };